import React from "react";
import { useField, ErrorMessage } from "formik";

function TextField({ label, placeholder, ...props }) {
  const [field] = useField(props);
  return (
    <>
      <div className="form_input_div" style={{marginBottom:".8rem"}}>
        <label>{ label }</label>
        <input
          type="text"
          id={field.name}
          {...field}
          {...props}
          placeholder={placeholder}
          autoComplete="off"
          className="form_input"
        />
        <ErrorMessage component="div" name={field.name} className="error" />
      </div>
    </>
  );
}

export default TextField;
